var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11670",
    "data-name": "Group 11670",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#35a826"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11669",
    "data-name": "Group 11669",
    transform: "translate(7.121 3.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49489",
    "data-name": "Path 49489",
    d: "M15.575,13.9l1.1-9.918,1.481.866a.463.463,0,0,0,.584-.7L15.329.167a.463.463,0,0,0-.7,0L11.214,4.149a.462.462,0,0,0,.582.7l1.483-.864,1.1,9.916a.6.6,0,0,0,1.2,0Z",
    transform: "translate(-11.098 -0.006)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusGreen);
export default __webpack_public_path__ + "static/media/status-green.85fbac42860554d34191844244362946.svg";
export { ForwardRef as ReactComponent };